"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StopOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var StopOutlineSVG = function StopOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5V27l.2.1H26.9l.1-.2V5.2 5l-.2-.1H5.2 5zm-2 .2C3 4 4 3 5.2 3h21.6C28 3 29 4 29 5.2v21.6c0 1.2-1 2.2-2.2 2.2H5.2C4 29 3 28 3 26.8V5.2z",
    clipRule: "evenodd",
    stroke: "none"
  }));
};
exports.StopOutlineSVG = StopOutlineSVG;
StopOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(StopOutlineSVG);
exports.default = _default;